// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zDbe","rootNoMargin":"styles_rootNoMargin__3iA59"};